<splash></splash>
<navigator (menuToggle)="menuRef.toggle()" *ngIf="layoutService.isLayoutPostLogin$ | async"></navigator>

<div class="page-content">
    <header *ngIf="layoutService.isLayoutPostLogin$ | async"></header>
    <app-menu #menuRef [ngClass]="{ 'full-width': !(layoutService.isLayoutPostLogin$ | async)}" [settings]="settings">
        <div [ngClass]="{
          'container-fluid': layoutService.isLayoutPostLogin$ | async,
          'layout-padding': layoutService.isLayoutPostLogin$ | async
        }">
            <router-outlet></router-outlet>
            <nio-footer *ngIf="layoutService.isLayoutPostLogin$ | async" [session]="session"></nio-footer>
        </div>
    </app-menu>
</div>
